<template>
    <v-form ref="form" v-if="item" @focusout.native="onFieldCommit">
        
        
        <v-card-title>
            <v-tabs v-model="tab" background-color="transparent" color="primary" style="width:auto;">
                <v-tab>Algemeen</v-tab>
                <v-tab>Integraties</v-tab>
            </v-tabs>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card-text v-if="['ARTICLE_FOLDER'].includes(item.class)">
            <v-text-field label="Naam" dense outlined v-model="item.name"></v-text-field>
        </v-card-text>
        <template v-else-if="item && !['ARTICLE_FOLDER'].includes(item.class)">
            <v-card-text>
                <!-- verplichte-velden-feedback via $toaster.notify (zie saveItem) -->
            <v-row class="mb-4">
                <v-col>
                    <v-row>
                    <v-col cols="12" :xl="6">
                        <eod-text-field
                            v-model="item.name"
                            :rules="[val => $validator.required(val, 'Naam')]"
                            label="Naam*"
                            required
                            outlined
                            hide-details
                            dense
                            :disabled="item.isReadonly"
                        ></eod-text-field>
                    </v-col>
                    <v-col cols="12" :xl="6">
                        <eod-text-field
                            v-model="item.description"
                            label="Omschrijving"
                            outlined
                            hide-details
                            dense
                            :disabled="item.isReadonly"
                        ></eod-text-field>
                    </v-col>
                    <v-col cols="12">
                        <eod-list-item-autocomplete :disabled="item.isReadonly" v-if="$eod.getOrganizationSetting('measurementTypes.units.listId')" v-model="item.unit" return-object label="Eenheid" :listId="$eod.getOrganizationSetting('measurementTypes.units.listId').value" outlined></eod-list-item-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" :xl="6">
                        <eod-objects-treeview-input :disabled="item.isReadonly" :searchConfig="Article.searchConfig" :selectable="[item.class+'_TYPE', item.class+'_FOLDER', item.class]" hide-type :classes="[item.class+'_TYPE', item.class+'_FOLDER', item.class]" :rules="[val => $validator.required(val, 'Bovenliggend item')]" required v-model="item.treeParentId" :exclude="item.id?[item.id]:null" label="Bovenliggend item*">
                            <template v-slot:append-item>
                                <v-divider></v-divider>
                                <v-list-item dense @click="isCreateTypeDialogVisible = true">
                                    <v-list-item-icon>
                                        <v-icon>mdi-plus</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Type toevoegen</v-list-item-title>
                                        <v-list-item-subtitle>Voeg een type toe wanneer u deze
                                            niet in de lijst vindt.</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </eod-objects-treeview-input>
                        <eod-dialog title="Type toevoegen" icon="mdi-plus" iconColor="primary" v-if="isCreateTypeDialogVisible" v-model="isCreateTypeDialogVisible" @okAction="createArticleType" okText="Toevoegen">
                            <v-form ref="articleTypeForm">
                                <v-alert type="error" v-if="typeFormErrors[0]" dense class="mt-2">
                                    <ul>
                                        <li v-for="(error, index) in typeFormErrors" :key="index">{{ error }}</li>
                                    </ul>
                                </v-alert>
                                <eod-article-type-detail class="mt-4" v-model="newArticleType"></eod-article-type-detail>
                            </v-form>
                        </eod-dialog>
                    </v-col>
                </v-row>
                <v-row v-if="item.articleType && item.articleType.id">
                    <v-col>                        
                        <eod-product-type-preview :value="item.articleType.id"></eod-product-type-preview>
                    </v-col>
                </v-row>
                <eod-custom-fields-item v-model="item.customFields" v-if="item.treeParentId" endpoint="articles" :id="item.id" :extraFields="[{module:'articleTypes', id: item.treeParentId}]"></eod-custom-fields-item>
                </v-col>
                <v-col cols="12" :lg="'auto'">
                    <v-img width="200" max-height="280" :src="qr_code" aspect-ratio="1" contain />
                </v-col>
            </v-row>

            <template v-if="$eod.getOrganizationSetting('articles.stockmovements.hide') && $eod.getOrganizationSetting('articles.stockmovements.hide').value">
                <eod-article-stock-movements v-if="item.id" :readonly="item.isReadonly" :value="item.id"></eod-article-stock-movements>
                <v-alert v-else dense text type="info">Gelieve eerst te bewaren om stockbewegingen toe te voegen.</v-alert>
            </template>
    </v-card-text>
</template>
    <v-card-text v-else-if="['TOOL_FOLDER'].includes(item.class)">
        <v-text-field label="Naam" dense outlined v-model="item.name"></v-text-field>
    </v-card-text>
            </v-tab-item>
            <v-tab-item>
                <v-card-text>
                <eod-integration-ids v-if="item.id" :itemId="item.id" endpoint="articles"></eod-integration-ids>
                <v-alert v-else type="info" text>Gelieve eerst te bewaren</v-alert>
            </v-card-text>
            </v-tab-item>
        </v-tabs-items>

</v-form>
</template>
<script>
import eodObjectAutocomplete from './eod-object-autocomplete.vue';
import eodObjectsTreeviewInput from './eod-objects-treeview-input.vue';
import eodProductTypePreview from './eod-product-type-preview.vue';
import eodArticleTypeDetail from './eod-article-type-detail.vue';
import eodArticleStockMovements from './eod-article-stock-movements.vue';
import eodListItemAutocomplete from './eod-list-item-autocomplete.vue';
import eodIntegrationIds from './eod-integration-ids.vue';
import eodCustomFieldsItem from './eod-custom-fields-item.vue';
import Article from './../models/article.js';

export default{
    name: 'eod-article-detail',
    components:{
        eodObjectAutocomplete,
        eodObjectsTreeviewInput,
        eodProductTypePreview,
        eodArticleTypeDetail,
        eodArticleStockMovements,
        eodListItemAutocomplete,
        eodCustomFieldsItem,
        eodIntegrationIds,
    },
    props:{
        value: String|Object
    },
    data: () => ({
        Article: Article,
        item: null,
        tab: 0,
        loading: false,
        savingTimeout: null,
        creating: false,
        saving: false,
        isSaveAlertVisible: false,
        isSavedSnackbarVisible: false,
        errors: null,
        missingFieldsToast: null,
        qr_code: null,
        isCreateTypeDialogVisible: false,
        newArticleType: {},
        typeFormErrors: [],
    }),
    created(){
        if(this.value){
            if(typeof this.value == 'string'){
                this.loading = true;
                
                this.$eod.getById('article', this.value, ['id', 'name', 'treeParentId', 'description', 'class', 'unit{id}', 'isReadonly', 'customFields{customFieldId, module, itemId, value}'])
                    .then(response => {
                        if(response && response.data.data && response.data.data.article){
                            this.item = new Article(response.data.data.article);
                            this.generateQRCode();
                        }else{
                            this.item = null;
                        }
                    }).finally(() => {
                        this.loading=false;
                    });
            }else{
                this.item = this.value;
                this.generateQRCode();
            }
        }
    },
    watch:{
        loading(val){
            this.$emit('loading', val);
        },
        item: {
            deep: true,
            handler() {
                // Autosave: stil valideren (geen inline rode meldingen), debounced.
                if (this.$refs.form) { this.$refs.form.resetValidation(); }
                clearTimeout(this.savingTimeout);
                if (this.loading) { return; }
                // Nieuw item niet tijdens het typen aanmaken (voorkomt meerdere
                // onvolledige duplicaten, #297): pas createn op een commit-moment
                // (focusout, zie onFieldCommit) of — als vangnet — na langere
                // inactiviteit. Bestaande items autosaven wél meteen (update).
                const isNew = !this.item.id;
                this.savingTimeout = setTimeout(
                    () => (isNew ? this.onFieldCommit() : this.saveItem(false)),
                    isNew ? 2500 : 500,
                );
            }
        }
    },
    methods:{
        generateQRCode(){
            // QR code
            if(this.item.id){
                this.$helper.generateQR('article', this.item.id).then(result => {
                    this.qr_code = result;
                });
            }
        },
        createArticleType(){
            if(this.$refs.articleTypeForm){
                const valid = this.$refs.articleTypeForm.validate();

                if(!valid){
                    this.typeFormErrors = [];
                    this.$refs.articleTypeForm.inputs.forEach(e => {
                        if (e.errorBucket && e.errorBucket.length) {
                            this.typeFormErrors.push(...e.errorBucket);
                        }
                    });

                    return false;
                }

                this.$eod.save('ArticleType', this.newArticleType).then((response) => {
                    if(response.data && response.data.data && response.data.data.createArticleType){
                        this.item.treeParentId = response.data.data.createArticleType.id;
                        this.isCreateTypeDialogVisible = false;
                        this.newArticleType = {};
                    }
                });
            }
        },
        getFormErrors() {
            const errors = [];
            this.$refs.form.inputs.forEach(e => {
                if (e.errorBucket && e.errorBucket.length) {
                    errors.push(...e.errorBucket);
                }
            });
            return errors;
        },
        onFieldCommit() {
            // Commit-moment voor een nog niet aangemaakt item: veld verlaten (blur) of
            // langere pauze. Pas dán aanmaken, en enkel als het formulier geldig is — zo
            // ontstaan er geen tussentijdse, onvolledige duplicaten (#297). Stille check:
            // bij een onvolledig formulier nog niet aanmaken en niet zeuren.
            if (this.loading || this.saving || this.creating) return;
            if (this.item.id || !this.$refs.form) return;
            if (!this.$refs.form.validate()) {
                this.$refs.form.resetValidation();
                return;
            }
            clearTimeout(this.savingTimeout);
            this.saveItem(false);
        },
        saveItem(showInlineErrors = true){
            this.errors = null;
            if(!this.$refs.form){
                return false;
            }

            const validation = this.$refs.form.validate();
            if(!validation){
                const formErrors = this.getFormErrors();
                if(formErrors.length && !this.missingFieldsToast){
                    // Blijft staan tot het formulier geldig is of de gebruiker erop klikt.
                    this.missingFieldsToast = this.$toaster.notify({
                        type: 'danger',
                        timeout: 0,
                        title: 'Gelieve verplichte velden in te vullen',
                        body: formErrors.join('<br>'),
                        onClose: () => { this.missingFieldsToast = null; }
                    });
                }
                if(!showInlineErrors){
                    // Autosave: geen inline rode meldingen die de invulvelden wegduwen.
                    this.$refs.form.resetValidation();
                }
                return false;
            }

            // Voorkom dubbele aanmaak: create al onderweg voor dit nieuwe item → skip.
            const isNew = !this.item.id;
            if(isNew && this.creating){
                return false;
            }
            // Geldig: sluit een eventuele "verplichte velden"-melding meteen; bij een
            // geslaagde opslag komt er een groene bevestiging in de plaats.
            const hadMissingToast = !!this.missingFieldsToast;
            if(this.missingFieldsToast){ this.missingFieldsToast(true); this.missingFieldsToast = null; }

            this.saving = true;
            if(isNew){ this.creating = true; }

            const data = (new Article(this.item)).getSaveData();
            this.$eod.save('Article', data)
                .then(response => {
                    if(response && response.data.data){
                        if(response.data.data.createArticle){
                            this.item.id = response.data.data.createArticle.id;
                            this.$emit('saved', response.data.data.createArticle.id);
                            this.$toaster.notify({ type: 'success', title: 'Artikel succesvol aangemaakt' });
                        }else if (response.data.data.updateArticle){
                            this.item.id = response.data.data.updateArticle.id;
                            this.$emit('saved', response.data.data.updateArticle.id);
                            // Groene bevestiging enkel na het oplossen van ontbrekende
                            // velden; gewone autosaves blijven stil.
                            if(hadMissingToast){ this.$toaster.notify({ type: 'success', title: 'Artikel succesvol aangepast' }); }
                        }
                    }
                })
                .finally(() => {
                    this.saving = false;
                    this.creating = false;
                });
        },
    }
}
</script>